module.exports = __webpack_public_path__ + "static/media/dami-adebayo-k6aQzmIbR1s-unsplash.6de9cc1d.jpg";